module.exports = __webpack_public_path__ + "static/media/icon-error-white.7a60cc1c.svg";